import { render, staticRenderFns } from "./Form12StyleOfProceeding.vue?vue&type=template&id=b5868de2&scoped=true"
import script from "./Form12StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form12StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form12StyleOfProceeding.vue?vue&type=style&index=0&id=b5868de2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5868de2",
  null
  
)

export default component.exports